import styled, { css } from 'styled-components';

const AdContainerStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  img,
  video,
  iframe {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 1;
    visibility: hidden;
  }

  ${(props) =>
    props.isAdLinear &&
    css`
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 1;
      background-color: black;

      img,
      video,
      iframe {
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        z-index: 1;
        width: 100%;
        height: 100%;
        visibility: visible;
      }
    `};
  ${(props) =>
    props.isHidden &&
    css`
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    `};
`;

export default AdContainerStyled;
